import 'react-app-polyfill/ie11';
import 'core-js/stable';
import { useEffect} from 'react';

function useKeyPress(handler) {
    
    // Add event listeners
    useEffect(() => {

       // If pressed key is our target key then set to true
    function downHandler({ key }) {
      if (key === 'Escape') {
          handler([]);
      }
    }
      window.addEventListener('keydown', downHandler);
      // Remove event listeners on cleanup
      return () => {
        window.removeEventListener('keydown', downHandler);
      };
    }); // Empty array ensures that effect is only run on mount and unmount
  
    return '';
  }

  export default useKeyPress;